var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 7,
    height: 17,
    fill: "#E6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1365 22.5284C15.5664 22.5284 15.9269 22.3828 16.2182 22.0915C16.5085 21.8013 16.6536 21.4412 16.6536 21.0114V14.9431C16.6536 14.5133 16.5085 14.1527 16.2182 13.8614C15.9269 13.5712 15.5664 13.426 15.1365 13.426C14.7067 13.426 14.3466 13.5712 14.0564 13.8614C13.7651 14.1527 13.6195 14.5133 13.6195 14.9431V21.0114C13.6195 21.4412 13.7651 21.8013 14.0564 22.0915C14.3466 22.3828 14.7067 22.5284 15.1365 22.5284ZM15.1365 10.3919C15.5664 10.3919 15.9269 10.2463 16.2182 9.95499C16.5085 9.66473 16.6536 9.30468 16.6536 8.87484C16.6536 8.44501 16.5085 8.08445 16.2182 7.79317C15.9269 7.50291 15.5664 7.35778 15.1365 7.35778C14.7067 7.35778 14.3466 7.50291 14.0564 7.79317C13.7651 8.08445 13.6195 8.44501 13.6195 8.87484C13.6195 9.30468 13.7651 9.66473 14.0564 9.95499C14.3466 10.2463 14.7067 10.3919 15.1365 10.3919ZM15.1365 30H14.7573C14.6308 30 14.5171 29.9747 14.4159 29.9241C11.1037 28.8875 8.37295 26.8329 6.22377 23.7603C4.07459 20.6888 3 17.2946 3 13.5778V6.40961C3 5.7775 3.18356 5.2086 3.5507 4.70291C3.91681 4.19722 4.39065 3.83059 4.97219 3.60303L14.0746 0.189633C14.4286 0.0632111 14.7826 0 15.1365 0C15.4905 0 15.8445 0.0632111 16.1985 0.189633L25.3009 3.60303C25.8824 3.83059 26.3568 4.19722 26.7239 4.70291C27.09 5.2086 27.2731 5.7775 27.2731 6.40961V13.5778C27.2731 17.2946 26.1985 20.6888 24.0493 23.7603C21.9001 26.8329 19.1694 28.8875 15.8571 29.9241C15.7307 29.9747 15.4905 30 15.1365 30Z",
    fill: "#09A3A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy_icon.0a84b7701c62cb77d6d7daff7bf935d5.svg";
export { ForwardRef as ReactComponent };